import "./assets/scss/hope-ui.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import { FaExclamationTriangle } from "react-icons/fa";
import { setSetting } from "./store/setting/actions";
import { Modal, Button } from "react-bootstrap";
import {
  openModal,
  closeModal,
} from "../src/services/redux/reducers/modalSlice";
import { useGlobalState } from "../src/services/hostelConst";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import "../src/components/partials/dashboard/SidebarStyle/custom-scroolbar.css";
import ScrollbarManager from "./components/partials/dashboard/SidebarStyle/ScrollbarManager";
import {
  ServerErrorProvider,
  useServerError,
} from "./handlers/ServerErrorContext";
import ErrorPage from "./views/dashboard/widget/ErrorPage";
import ModalBodyRenderer from "./modal/modalBodyRenderer"; // Add this import

const InnerApp = ({ children }) => {
  const { serverErrorVisible, setServerErrorVisible } = useServerError();
  useEffect(() => {
    let timer;
    if (serverErrorVisible) {
      timer = setTimeout(() => {
        setServerErrorVisible(false);
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [serverErrorVisible, setServerErrorVisible]);
  return (
    <div className="App">
      <div
        id="notification98"
        className="pixel-corners"
        style={{ display: "block" }}
      ></div>
      {children}
      {serverErrorVisible && (
        <ErrorPage
          onRetry={() => setServerErrorVisible(false)}
          onClose={() => setServerErrorVisible(false)}
        />
      )}
    </div>
  );
};

function App({ children }) {
  const {
    concentModalState,
    openConcentModal,
    closeConcentModal,
    setIsEditing,
    closeModal: closeGlobalModal,
    isEditing,
  } = useGlobalState();

  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modal);

  // Move the dispatch to useEffect to avoid render-time state updates
  useEffect(() => {
    dispatch(setSetting());
  }, [dispatch]); // Only run once when component mounts

  return (
    <>
      <ScrollbarManager />
      <Modal
        size={modal.size || "lg"} // Use modal.size if available, fallback to "lg"
        scrollable={true}
        show={modal.isOpen}
        centered
        onHide={() => {
          dispatch(closeModal());
        }}
      >
        {modal.isHeader === true ? (
          <Modal.Header closeButton>
            <Modal.Title className="text-primary">
              {modal.isEditing === false ? "Add" : "Edit"} {modal.title}
            </Modal.Title>
          </Modal.Header>
        ) : null}

        <Modal.Body>{modal.body}</Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal
        container={document.body}
        show={concentModalState.isOpen}
        onHide={closeConcentModal}
        centered
      >
        {concentModalState.body}
      </Modal>
      <ServerErrorProvider>
        <div className="App">
          <div
            id="notification98"
            className="pixel-corners"
            style={{ display: "block" }}
          ></div>
          {/* <IndexRouters /> */}
          <InnerApp>{children}</InnerApp>
        </div>
      </ServerErrorProvider>
    </>
  );
}

export default App;
